<template>
  <div>


    <m-confirm-list ref="confirm"></m-confirm-list>
    <m-choose-booking ref="chooseBooking"></m-choose-booking>
    <m-booking-edit-form :form="form" :booking="selectedItem" :dialog="dialog_booking" @update="onUpdateBooking" @close="onCloseBooking"></m-booking-edit-form>

    <div class="booqit">

      <v-toolbar extended flat color="white">
        <v-toolbar-title>Booqit transports</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>

        <v-spacer></v-spacer>

        Total: {{ totalAmount | currency(true) }}

        <template v-if="extendedSlot" #extension>

          <v-menu
            :close-on-content-click="false"
            v-model="menu_date_start"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                label="Start date"
                v-model="dateFormatted_start"
                prepend-icon="event"
                readonly
                  hide-details
              ></v-text-field>
            </template>

            <v-date-picker v-model="booqitDate.start" scrollable
              @input="dateFormatted_start = formatDate($event)"
              @change="onChangeDate"
            >
            </v-date-picker>
          </v-menu>

          <v-menu
            :close-on-content-click="false"
            v-model="menu_date_end"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                label="End date"
                v-model="dateFormatted_end"
                prepend-icon="event"
                readonly
                hide-details
              ></v-text-field>
            </template>


            <v-date-picker v-model="booqitDate.end" scrollable
            @input="dateFormatted_end = formatDate($event)"
            @change="onChangeDate"
            :min="booqitDate.start"
            >
            </v-date-picker>
          </v-menu>

          <v-spacer></v-spacer>

          <v-btn-toggle v-model="btn_filter" color="primary" @change="setBooqitFilter" class="mx-1">
            <v-btn small outlined ><v-icon small class="mr-1" color="grey" >filter_alt </v-icon>Pas facture</v-btn>
            <v-btn small outlined ><v-icon small class="mr-1" color="grey" >filter_alt </v-icon>Certificate</v-btn>
          </v-btn-toggle>

          <v-menu
            v-model="menu_filter"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-btn small :color="booqitFilter.length ? 'primary' : 'grey lighten-2'" outlined v-on="on">
                 <v-icon>tune</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-text>
              <v-switch v-model="booqitFilter" color="primary" label="Facturé" value="invoiced"></v-switch>
              <v-switch v-model="booqitFilter" color="primary" label="A facturer" value="invoiceable"></v-switch>
              <v-switch v-model="booqitFilter" color="primary" label="Facturation démarée" value="invoicingStarted"></v-switch>
              <v-switch v-model="booqitFilter" color="primary" label="Certificat requis" value="certificateNeeded"></v-switch>
              <v-switch v-model="booqitFilter" color="primary" label="Certificat attaché" value="certificatePresent"></v-switch>
              <v-switch v-model="booqitFilter" color="primary" label="Certificat envoyé" value="certificateSent"></v-switch>
              <v-switch v-model="booqitFilter" color="primary" label="Pas d'intervention" value="noMutInvoicingIntervention"></v-switch>
              </v-card-text>
            </v-card>
          </v-menu>



          <v-btn small color="primary" dark class="ma-1" @click="getTransports"><v-icon small class="mr-1">refresh </v-icon>transports </v-btn>

        </template>
      </v-toolbar>

      <v-toolbar  flat color="white">

        <v-text-field
          class="mr-5"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search_booqits"
        ></v-text-field>

        <v-btn icon class="mx-0 hidden-sm-and-down" @click="clear">
          <v-icon color="primary">delete</v-icon>
        </v-btn>

        <download-csv :name="downloadName" separator-excel :data="downloadData"><v-icon color="primary">save</v-icon></download-csv>

        <v-dialog
            v-model="dialog_loader"
            persistent
            width="300"
          >
          <v-card
            color="primary"
            dark
          >
            <v-card-text class="pt-3">
              Please stand by
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

      </v-toolbar>


      <v-data-table
        ref="dataTable"
        :headers="headers"
        :items="filteredBooqit"
        :options.sync="options"
        :sort-by="['dateTime']"
        :sort-desc="[true]"
        :key="componentKey"
        item-key="transportId"
        :footer-props="{'items-per-page-options': [30, 40, {text:'All', value:-1}] }"
        class="elevation-1"
        id="result"
      >
        <template v-slot:body="{ items }" >
            <tbody >
              <tr v-for="item in items" :key="item.name" :class="{'isDone':item[0].isDone}">
                <td @click="expandme(item)">
                  <div>
                    <v-icon v-if="item[1]" small>all_inclusive</v-icon>
                  </div>
                </td>
                <td class="text-xs-left"><div>{{ item[0].transportId }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].dateTime | datetime}}</div></td>
                <td class="text-xs-left"><div>{{ item[0].passenger }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].reason }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].pickup }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].dropOff }}</div></td>
                <td class="text-xs-left no-break"><div>{{ item[0].price | currency}}</div></td>
                <td class="text-xs-left no-break"><div>{{ item[0].total | currency}}</div></td>
                <td class="text-xs-right">
                  <div>
                  <v-icon
                    small
                    class="mr-2"
                    @click="viewItem(item[0])"
                  >
                    visibility
                  </v-icon>

                  <v-icon
                    small
                    class="mr-2"
                    @click="getBookingByTransportIds(item[0].transportId)"
                  >
                    edit
                  </v-icon>
                  </div>
                </td>
              </tr>

            </tbody>
        </template>
        <template v-slot:no-data>
          no data
        </template>
      </v-data-table>

    </div>


  </div>
</template>
<script>
/*
 {label: "forfait10km", km: 10, costTotal: 16}
 {label: "from11to30", km: 20, costUnit: 1.78, costTotal: 35.6}
 {label: "above30", km: 64, costUnit: 1.2, costTotal: 76.8}
*/
  import moment from 'moment';
  import CSVMixin from '@/mixins/CSVMixin'
  import BooqitMixin from '@/mixins/booqit'
  import JsonCSV from 'vue-json-csv'

  export default {
    name: 'booqitTransportComponent',
    mixins: [BooqitMixin, CSVMixin],
    data () {
      return {
        menu_date_start: false,
        menu_date_end: false,
        menu_filter: false,
        btn_filter: false,
        extendedSlot: true,
        date_start: moment().format('YYYY-MM-DD'),
        date_end: moment().add(1, 'days').format('YYYY-MM-DD'),
        dateFormatted_start: null,
        dateFormatted_end: null,
        tagsArr: [],
        tags: '',
        premade: [
          ['certificateNeeded','invoiceable'],
          ['certificateNeeded','invoicingStarted']
        ],
        headers: [
          { text: '', value: 'back' },
          { text: 'Id', value: 'transportId' },
          { text: 'dateTime', value: 'dateTime' },
          { text: 'passenger', value: 'passenger' },
          { text: 'reason', value: 'reason' },
          { text: 'pickup', value: 'pickup' },
          { text: 'dropOff', value: 'dropOff' },
          { text: 'price', value: 'total' },
          { text: 'total', value: 'total' },
          { text: 'Actions', value: 'name', sortable: false }
        ]
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onChangeDate () {
        console.log('onChangeDate: ', this.booqitDate.start, this.booqitDate.end);
        this.menu_date_start = this.menu_date_end = false;
      },
      setBooqitFilter (value) {
        console.log('setBooqitFilter: ', value)
        if (this.premade[value]) {
          this.booqitFilter = this.premade[value];
        } else {
          this.booqitFilter = []
        }
      },
      getTransports() {
        var tags = '';
        var currentDate = moment(this.booqitDate.start).utc().toJSON();
        var futureMonth = moment(this.booqitDate.end).utc().toJSON();
        var dates = [currentDate,futureMonth];
        tags = this.booqitFilter.toString().replace(',',';');
        // var tags = 'invoiceable;certificateNeeded';
        this.transports(dates, tags);
      },
      onDownload () {
        return this.filteredBooqit.map((item) => {
          let data = {
              dateTime: moment(item[0].dateTime).format('YYYY-MM-DD HH:mm'),
              client: item[0].passenger.toString('utf8'),
              destination: item[0].dropOff,
              reason: item[0].reason,
              transportId: item[0].transportId
          };
          data.price = item[0].total;
          return data;
        });
      }
    },
    computed: {
      downloadData: {
        cache: false,
        get () {
          var r = this.onDownload()
          console.log(r)
          return r
        }
      },
      downloadName:{
        cache: false,
        get () {
          return 'booqit-' + this.dateFormatted_start + '-' + this.dateFormatted_end + '.csv';
        }
      },
      totalAmount () {
        return this.filteredBooqit.reduce((sum, a) => sum + (Number(a[0].total) * a.length), 0);
      }
    }
  }
  </script>
<style lang="scss">
.booqit{
  .executed {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  .toConfirmAssignment, .toConfirmDelete {
    background:rgba(248, 1, 1, 0.1) !important;
  }
  .no-break {
    white-space: nowrap;
  }
  .notchecked {
    color: red;
  }
  .isDone {
    color: green;
  }
  table {
    border-collapse: collapse;
  }
  tr.not-expanded td {
    height: inherit;
  }
  tr.not-expanded td div {
    max-height: 0;
    overflow: hidden;
  }
  tr.expanded {
    box-shadow:inset 0px 0px 0px 5px rgb(240, 238, 238);
    td div {
      padding: 5px;
      max-height: 100px;
      overflow: hidden;
    }
  }

  .theme--light.v-table tbody tr:hover {
    background: inherit;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
      padding: 0 12px;
      max-width: 200px;
  }
}
</style>
